import React, { Component } from "react";
import { connect } from "react-redux";
import material2 from "./material2";
import store from "../../store/store";
import { VictoryArea, VictoryChart, VictoryAxis, VictoryLabel, VictoryTheme } from 'victory';
import Button from "@material-ui/core/Button";
import ButtonGroup from '@material-ui/core/ButtonGroup';
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";

const countries = [
	{
		value: "0",
		label: "Global"
	},
	{
		value: "1",
		label: "Argentina"
	},
	{
		value: "2",
		label: "Chile"
	},
	{
		value: "3",
		label: "Uruguay"
	},
	{
		value: "4",
		label: "Paraguay"
	}
];


const categorias = [
    {
		value: "0",
		label: "Todas las categorias"
	},
	{
		value: "1",
		label: "Soliqua"
	},
	{
		value: "2",
		label: "Toujeo"
	},
	{
		value: "3",
		label: "Perfil de Pacientes"
	},
	{
		value: "4",
		label: "Estrategia Promocional"
	}
];

class Analytics extends Component {


    constructor(props) {
		super(props);
		this.state = {
      		antime:1,
      		ancountry:0,
      		ancategory:0
		};
	}
	
    componentDidMount() {

  	}

	render() {

		const my_data = this.props.analytics;

        return (<React.Fragment>
            
          <h1>Preguntas Correctas</h1>
          <div></div>
          <div style={{ width: "100%", textAlign: "left", marginBottom: "20px", float: "right" }}>
            <ButtonGroup size="large" color="primary" aria-label="outlined primary button group">
              <Button variant={this.state.antime === 1 ? "contained" : "outlined"} 
				onClick={()=>{this.setState({antime:1});
							  this.props.loadAnalytics({
								"period":1, 
								"country":this.state.ancountry, 
								"category":this.state.ancategory}); 
							  }}>
                  General
              </Button>
              <Button variant={this.state.antime === 2 ? "contained" : "outlined"}  
                onClick={()=>{this.setState({antime:2});
								this.props.loadAnalytics({
								"period":2, 
								"country":this.state.ancountry, 
								"category":this.state.ancategory}); 
								}}>
                  Mes
              </Button>
              <Button variant={this.state.antime === 3 ? "contained" : "outlined"}  
                onClick={()=>{this.setState({antime:3});
								this.props.loadAnalytics({
								"period":3, 
								"country":this.state.ancountry, 
								"category":this.state.ancategory}); 
								}}>
                  Semana
              </Button>
            </ButtonGroup>
          </div>
          <div style={{ width: "100%", textAlign: "left", marginBottom: "20px" }}>
            <TextField
								id="standard-select"
								select
								label="Categoria"
								style={{
									marginBottom: "20px",
									width: "90%",
									textAlign: "left"
								}}
								value={this.state.ancategory}
								onChange={value =>{
									this.setState({ancategory: value.target.value });
									this.props.loadAnalytics({
										"period":this.state.antime, 
										"country":this.state.ancountry, 
										"category":value.target.value});
								}}	
							>
								{categorias.map(option => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								))}
							</TextField>
              {" "}
              <TextField
								id="standard-select"
								select
								label="Pais"
								style={{
									marginBottom: "20px",
									width: "90%",
									textAlign: "left"
								}}
								value={this.state.ancountry}
								onChange={value =>{
									this.setState({ancountry: value.target.value });
									this.props.loadAnalytics({
										"period":this.state.antime, 
										"country":value.target.value, 
										"category":this.state.ancategory});
								}}	
							>
								{countries.map(option => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								))}
							</TextField>
          </div>
          <div></div>
		  
            <div style={{width:"100%", height:"850px"}}>

            <VictoryChart
            
              theme={material2}
            >
            <VictoryAxis    
              dependentAxis
              tickFormat={(y) => (`${y}%`)}
            />
            <VictoryArea
                style={
                   {
                    data: {fill: "#01F248", fillOpacity: 1, stroke: "#199900", strokeWidth: 3,fontSize: 3},
                    labels: { fontSize: 8, fill: "#FFFFFF" }
                   }
                }
                theme={material2}

				labels={({ datum }) => datum.x +", \n"+ datum.y + "%"}
				labelComponent={<VictoryLabel renderInPortal dy={-20} backgroundStyle={{ fill: "#000000" }} backgroundPadding={3}/>}
                width={200}
                height={10}
                data={my_data}
            />
                     <VictoryAxis/>
        </VictoryChart>
        </div>
        </React.Fragment>);

        
    }


}

export default Analytics;